;(function () {
  'use strict'

  angular
    .module('contrast.common')
    .controller(
      'RegisterCtrl',
      function RegisterCtrl(
        $scope,
        $routeParams,
        $location,
        logger,
        CommonFactory,
        policy
      ) {
        'ngInject'

        angular.extend($scope, {
          saving: false,
          model: {
            email: $routeParams.email,
            token: $routeParams.token
          },
          password: '',
          helper: {
            passwordvalid: false,
            confirmpassword: '',
            policy: angular.copy(policy)
          }
        })

        angular.extend($scope, {
          update: update
        })

        function update() {
          $scope.saving = true
          return CommonFactory.register($scope.model)
            .then(function (response) {
              logger.logSuccess(response.data.messages[0])
              $scope.model = {}
              $scope.form.$setPristine()
              $location.path('/pages/signin', true)
            })
            .catch(function (response) {
              logger.logError(response.data.messages[0])
              $location.path('/pages/signin', true)
            })
            .finally(function () {
              $scope.saving = false
            })
        }
      }
    )
})()
